var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 14.0625H1.7625C1.34246 14.0625 1.13244 14.0625 0.972007 13.9808C0.830886 13.9089 0.71615 13.7941 0.644245 13.653C0.5625 13.4926 0.5625 13.2825 0.5625 12.8625V0.5625M14.0625 3.5625L9.98676 7.63824C9.83826 7.78674 9.764 7.861 9.67838 7.88882C9.60307 7.91329 9.52193 7.91329 9.44662 7.88882C9.361 7.861 9.28674 7.78674 9.13824 7.63824L7.73676 6.23676C7.58826 6.08826 7.514 6.014 7.42838 5.98618C7.35307 5.96171 7.27193 5.96171 7.19662 5.98618C7.111 6.014 7.03674 6.08826 6.88824 6.23676L3.5625 9.5625M14.0625 3.5625H11.0625M14.0625 3.5625V6.5625",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/Markets.b3ade380f317ceb0fab44006f37872e6.svg";
export { ForwardRef as ReactComponent };